import React from 'react';
import {InputNumber, AutoComplete, Modal, Form, Icon, Input, Button, message, Radio, Row, Select,Switch } from 'antd';
import {connect} from "react-redux";
import {updateCheckinpoint} from "../../services/checkinpoint";
import lodash from "lodash"
import EvtAddressMap from "./EvtAddressMap";
import {isValidity} from "../../services/global";
import PurchaseServiceTips from "../PurchaseServiceTips";



class EvtViewCheckinpointDes extends React.Component {




    constructor(props) {
        super(props);
        this.pstView =null;
        this.evtAddressMap = null;
        this.state = {
            isMember:'MEMBER',
            permissionPass: false,
            addressAutoCompleteDataSource: [],
            formLoading: false,


        }
    }

    componentDidMount() {
        isValidity('DISTANCECHECKIN', (vaild) => this.setState({ permissionPass: vaild}));
    }

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    };

    onSubmit = () => {
        if (!this.state.permissionPass) {
            this.pstView.show();
        } else {
            this.props.form.validateFieldsAndScroll((error, values) => {
                if (!error) {
                    if (!values.openCheckinDistance) {
                        values.address = '';
                        values.lat = '';
                        values.lng = '';
                    }else {
                        if(!values.lat || !values.address){
                            message.info('请点击地图坐标获取准确的定位置！')
                            return;
                        }
                    }
                    updateCheckinpoint(Object.assign(this.props.data, values)).then(res => {
                        if (res.code === 200) {
                            message.info("保存成功!");
                            this.props.editableChange(this.props.editableStatePropName, false, true)
                        } else {
                            message.error(res.msg,6);
                        }
                    }).catch(err => {
                        message.warn("访问异常");
                    }).finally(() => {
                        this.changeFormLoading(false)
                    })


                } else {

                }
            });
        }
    }




    render() {
        const {getFieldDecorator,getFieldsValue,setFieldsValue} = this.props.form;
        const {data} = this.props;
        getFieldDecorator('lat', {initialValue:data.lat ? data.lat : ""});
        getFieldDecorator('lng', {initialValue: data.lng ? data.lng : ""});
        const formItemLayout = {
            labelCol: {
                xs: {span: 3},
                sm: {span: 3},
            },
            wrapperCol: {
                xs: {span: 20},
                sm: {span: 20},
            },
        };




        return (
            <div>
                <Modal
                    width={750}
                    title={`签到点-${data.name}(定位)`}
                    visible={this.props.visible}
                    onCancel={() => this.props.hide()}
                    footer={[
                        <Button key="back" onClick={()=>this.props.hide()}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.onSubmit}>
                            保存
                        </Button>,
                    ]}
                >
                    <div>
                        <Form.Item
                            {...formItemLayout}
                            label={(
                                <span>
                                        GPS定位
                                    </span>
                            )}>
                            {getFieldDecorator(`checkinDistance`, {
                                initialValue: data.checkinDistance ? data.checkinDistance : 200,
                                rules: [{required: true,message: '必填项'},],
                            })(
                                <InputNumber min={20}
                                             max={2000}
                                             precision={0}
                                />
                            )} <span style={{color:'#959595'}}>默认200米，不低于20米，不超出2000米</span>
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="开启定位签到"
                        >
                            {getFieldDecorator(`openCheckinDistance`, {
                                initialValue: data.address ? true : false,
                                valuePropName: 'checked',
                                rules: [{required: false}],
                            })(
                                <Switch checkedChildren={"开启"} unCheckedChildren={"关闭"}/>
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label={(
                                <span>
                                        签到点地址
                                    </span>
                            )}
                        >
                            <div style={{width: "100%"}}>

                                {getFieldDecorator('address', {
                                    initialValue: data.address,
                                    rules: [
                                        {whitespace: true, message: '不能输入空格!'},
                                        {min: 2, max: 100, message: '长度限制为2至100个之间!'}
                                    ],
                                })(
                                    <AutoComplete
                                        style={{width: "100%"}}
                                        backfill={true}
                                        dataSource={this.state.addressAutoCompleteDataSource}
                                        onSelect={(val, option) => {
                                            const location = option.props.district ? (option.props.district + option.props.address + option.props.name) : option.props.name;
                                            this.evtAddressMap.setValue(option.props.location, location, true);
                                        }}
                                        onSearch={(searchText) => {
                                            if (this.evtAddressMap) {
                                                this.evtAddressMap.autocompleteSearch(searchText, (status, result) => {
                                                    console.log("autocompleteSearch", searchText, status, result)
                                                    this.setState({
                                                        addressAutoCompleteDataSource: status == "complete" ? result.tips.map(t => <Select.Option
                                                            key={`${t.name}${t.adcode}${t.id}`}  {...t}>{t.district ? (t.district + t.address + t.name) : t.name}</Select.Option>) : [],
                                                    })
                                                });
                                            }
                                        }}
                                    >
                                        <Input.TextArea autosize={{minRows: 1, maxRows: 2}}/>
                                    </AutoComplete>
                                )}

                                <div style={{width: "100%", height: "300px"}}>
                                    <EvtAddressMap
                                        ref={(comp) => this.evtAddressMap = comp}
                                        location={data.address}
                                        position={{longitude: data.lng, latitude: data.lat}}
                                        onChange={(lnglat, location) => {
                                            var fieldsValue = getFieldsValue();
                                            lodash.set(fieldsValue, `address`, location);
                                            lodash.set(fieldsValue, `lng`, lnglat.lng);
                                            lodash.set(fieldsValue, `lat`, lnglat.lat);
                                            console.log(fieldsValue)
                                            console.log(lnglat.lng)
                                            console.log(lnglat.lat)
                                            setFieldsValue(fieldsValue);
                                        }}
                                    />
                                </div>
                            </div>
                        </Form.Item>
                    </div>

                </Modal>
                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={this.state.isMember}
                />
            </div>
        );
    }
}


EvtViewCheckinpointDes.contextTypes = {};

EvtViewCheckinpointDes.defaultProps = {};

EvtViewCheckinpointDes.propTypes = {}


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewCheckinpointDes));




// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewCheckinpointDes.jsx